.root {
	pointer-events: none;
	position: fixed;
	top: var(--m-sp-md);
	right: var(--m-sp-md);
	z-index: 1000;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--m-sp-md);
	border-radius: var(--m-surface-rd);
	opacity: 1;
	transition: opacity var(--m-dur-short) var(--m-ease);
	transition-delay: 0.5s;
	@apply --mx-bg(var(--m-gray-wash));

	&[aria-hidden='true'] {
		opacity: 0;
	}
}

.spin {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
